import { render, staticRenderFns } from "./TitleTextButton.vue?vue&type=template&id=8893c2ca&scoped=true&"
import script from "./TitleTextButton.vue?vue&type=script&lang=js&"
export * from "./TitleTextButton.vue?vue&type=script&lang=js&"
import style0 from "./TitleTextButton.vue?vue&type=style&index=0&id=8893c2ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8893c2ca",
  null
  
)

export default component.exports